module.exports = __webpack_public_path__ + "static/media/history_26.f6157b86.jpg";